
function $parcel$import(url) {
  url = parcelRequire.i?.[url] || url;
  return import($parcel$distDir + url);
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree2e0"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree2e0"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8Byed", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("wwFYm"),
    $parcel$import("gRrHH"),
    $parcel$import("khKxQ")
]).then(()=>parcelRequire('2foiG'));

});

parcelRegister("cqwMY", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("wwFYm"),
    $parcel$import("gRrHH"),
    $parcel$import("89YqR")
]).then(()=>parcelRequire('7J5GQ'));

});

var $3832f8803b4d490c$exports = {};
$parcel$extendImportMap({
    "khKxQ": "entrance-mobile.33ff7bd3.js",
    "gRrHH": "entrance-mobile.cde4202b.js",
    "wwFYm": "entrance-mobile.8ba19e38.js",
    "89YqR": "entrance.56e5f178.js"
});

/**
 * homepage-entrance.js — top-level entry attached via Drupal library.
 *
 * Does cheap eligibility checks synchronously, then lazy-loads the heavy
 * orchestrator (three.js + GSAP + DotLottie) in the next idle window.
 * Keeps the LCP budget clean.
 */ function $eb57fe29b1ce6323$var$ready() {
    return document.readyState === 'loading' ? new Promise((r)=>document.addEventListener('DOMContentLoaded', r, {
            once: true
        })) : Promise.resolve();
}
function $eb57fe29b1ce6323$var$prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}
function $eb57fe29b1ce6323$var$hasWebGL() {
    try {
        const c = document.createElement('canvas');
        return !!(c.getContext('webgl2') || c.getContext('webgl'));
    } catch (e) {
        return false;
    }
}


async function $eb57fe29b1ce6323$var$boot() {
    await $eb57fe29b1ce6323$var$ready();
    const root = document.querySelector('[data-entrance-root]');
    if (!root) return;
    if ($eb57fe29b1ce6323$var$prefersReducedMotion() || !$eb57fe29b1ce6323$var$hasWebGL()) {
        root.classList.add('is-fallback');
        return;
    }
    // Branch by viewport. Mobile gets its own portrait orchestrator; the
    // desktop orchestrator stays untouched. Cross-breakpoint reload listeners
    // live inside each orchestrator so a resize across 992px reboots cleanly
    // into the right module.
    const isMobile = window.matchMedia('(max-width: 992px)').matches;
    const runBoot = async ()=>{
        try {
            if (isMobile) {
                const mod = await (parcelRequire("8Byed"));
                await mod.initEntranceMobile();
            } else {
                const mod = await (parcelRequire("cqwMY"));
                await mod.initEntrance();
            }
        } catch (err) {
            console.warn('[entrance] orchestrator load failed; fallback remains.', err);
            root.classList.add('is-fallback');
        }
    };
    // Lazy-load so it's off the LCP critical path.
    if ('requestIdleCallback' in window) requestIdleCallback(runBoot, {
        timeout: 2000
    });
    else setTimeout(runBoot, 0);
}
$eb57fe29b1ce6323$var$boot();


//# sourceMappingURL=homepage-entrance.js.map
